module.exports = __webpack_public_path__ + "82be6db1e6f23a25f3638351ca5ae19d.pdf";